"use client";

import {
    Form,
    FormControl,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form"
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import ReCAPTCHA from "react-google-recaptcha";
import { Spinner } from "../ui/Spinner";
import { useContactForm } from "@/hooks/contact/useContactForm";


export const ContactForm = () => {

    const { form, onSubmit, recaptchaRef, isLoading } = useContactForm();

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSubmit)} className="flex flex-col gap-5 mt-10 w-full max-w-[400px]">
                <FormField
                    control={form.control}
                    name="name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="block">Nombre</FormLabel>
                            <FormControl>
                                <Input placeholder="Nombre" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="email"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="block">Correo electrónico</FormLabel>
                            <FormControl>
                                <Input placeholder="Correo electrónico" type="email" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="cellphone"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="block">Celular</FormLabel>
                            <FormControl>
                                <Input placeholder="Celular" type="text" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <FormField
                    control={form.control}
                    name="message"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel className="block">Mensaje</FormLabel>
                            <FormControl>
                                <Textarea placeholder="Mensaje" className="resize-none" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />

                <Button type="submit">
                    {
                        isLoading ? (<Spinner size="20px" color="white" />) : "Enviar"
                    }
                </Button>

            </form>
            <ReCAPTCHA
                ref={recaptchaRef}
                size="invisible"
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ?? ''}
            />
        </Form>
    )
}
